import React from 'react';
import './Dashboard.css';

function Orders() {
    return (
        <div className="dashboard-container">
            <header className="dashboard-header card">
                <div className="welcome-text">
                    <h1>Orders Management</h1>
                    <p>View and manage customer orders</p>
                </div>
            </header>

            {/* <div className="info-sections">
                <section className="info-card card">
                    <div className="info-header">
                        <h3>Orders</h3>
                    </div>
                    <div className="info-content-grid">
                        <p>Orders management interface will be implemented here.</p>
                    </div>
                </section>
            </div> */}
        </div>
    );
}

export default Orders;
